module.exports = __webpack_public_path__ + "static/img/fx2-new-era.a2c0865.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/fx2-new-era.jpg
// module id = MUWE
// module chunks = 12